import React from 'react';
import { bool, shape, string } from 'prop-types';

const OpenInFull = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z" fill="currentColor" />
  </svg>
);

OpenInFull.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default OpenInFull;
